import styled from "styled-components"

const RowStyled = styled.div`
    position: relative;
    width: 100%;
    height: 2em;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const VolumeLevelStyled = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    opacity: 0.1;

`

export { RowStyled, VolumeLevelStyled }